import {
    PRODUCT_LIST_PAGE_LOADED,
    PRODUCT_LIST_PAGE_UNLOADED,
    PRODUCT_DETAIL_PAGE_LOADED,
    PRODUCT_DETAIL_PAGE_UNLOADED,
    PRODUCT_UPDATE_LOADED,
    PRODUCT_UPDATE_UNLOADED,
    PRODUCT_UPDATE,
    PRODUCT_DELETE,
    PRODUCT_LOAD_USER_CATEGORIES
} from '../constants/actionTypes'
export default (state = {}, action) => {
    switch (action.type) {
        case PRODUCT_LIST_PAGE_LOADED:
            return {
                ...state,
                products: action.payload.products,
            }
        case PRODUCT_LIST_PAGE_UNLOADED:
        case PRODUCT_DETAIL_PAGE_UNLOADED:
        case PRODUCT_UPDATE_UNLOADED:
            return {}
        case PRODUCT_DETAIL_PAGE_LOADED:
            return {
                ...state,
                product: action.payload[0].product,
                logs: action.payload[1].logs,
            }
        case PRODUCT_UPDATE_LOADED:
            return {
                ...state,
                product: action.payload.product,
            }
        case PRODUCT_LOAD_USER_CATEGORIES:
            return {
                ...state,
                categories: action.payload.categories,
                updated: false,
                removed: false
            }
        case PRODUCT_UPDATE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : true
            };
        case PRODUCT_DELETE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
                removed: action.error ? false : true
            };
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/product.js